<form class="ml-2 mb-3 mt-4">
  <table width="600" class="tablilla">
    <tr>
      <td>Datos del Paciente</td>
    </tr>
    <tr>
      <td class="izq">Nombre(*):</td>
      <td>
        <input
          type="text"
          name="nombre"
          [(ngModel)]="datosPaciente.nombre"
          class="default"
        />
      </td>
      <td class="izq">Cédula(*)</td>
      <td>
        <input
          type="number"
          name="cedula"
          [(ngModel)]="datosPaciente.cedula"
          class="default"
        />
      </td>
    </tr>
    <tr>
      <td class="izq">G&eacute;nero(*):</td>
      <td>
        <fieldset [(ngModel)]="datosPaciente.genero" id="genero" name="genero" ngDefaultControl>
          Hombre: <input type="radio" name="genero" value="Masculino" />
          Mujer : <input type="radio" name="genero" value="Femenino" />
        </fieldset>
      </td>
      <td class="izq">Edad(*):</td>
      <td>
        <select [(ngModel)]="datosPaciente.edad" name="edad" class="default">
          <option *ngFor="let i of numbers" value="{{ i }}">{{ i }}</option>
        </select>
        <b>años</b>
      </td>
    </tr>
    <tr>
      <td class="izq">Peso(*):</td>
      <td>
        <input
          [(ngModel)]="datosPaciente.peso"
          type="number"
          name="peso"
          class="default"
        />
      </td>
      <td class="izq">Estatura(*):</td>
      <td>
        <input
          [(ngModel)]="datosPaciente.estatura"
          type="number"
          name="estatura"
          size="12"
          class="default"
        />
        <b>c.m.</b>
      </td>
    </tr>
    <tr>
      <td>Datos del Médico</td>
    </tr>
    <tr>
      <td class="izq">Nombre:</td>
      <td><input type="text" name="nombreMed" class="default" [(ngModel)]="datosDoctor.nombre" /></td>
      <td class="izq">Especialidad:</td>
      <td>
        <select name="especialidad" class="default" [(ngModel)]="datosDoctor.especialidad">
          <option value="general">Médico General</option>
          <option value="psicologo">Psicologo</option>
          <option value="nutricionista">Nutricionista</option>
          <option value="odontolgo">Odontólogo</option>
          <option value="otro">Otro</option>
        </select>
      </td>
    </tr>
  </table>
  <br />
  <legend>Reporte</legend>
  <table width="720" class="tablilla">
    <tr>
      <td class="izq">Diagnostico:</td>
      <td>
        <textarea
          name="diagnostico"
          cols="50"
          rows="3"
          class="default"
          [(ngModel)]="reporte"
        ></textarea>
      </td>
    </tr>
  </table>
  <div class="mt-2 row justify-content-around">
    <button type="reset" class="btn btn-danger">Limpiar</button>
    <a><button type="submit" class="btn btn-info" (click)="exportToPDF()" >Enviar</button></a>
    
  </div>
</form>

<div class="d-none container" id="exportToPDF">
    <div class="mb-0 row justify-content-around">
        <h3><strong>MEDABI</strong> - Informe</h3>
        <h3><strong>Fecha:</strong> {{ fecha }}</h3>
    </div>
    <h3 class="mx-3"><strong>Datos del Paciente</strong></h3>
    <div class="row justify-content-around">
        <h5><strong>Nombre:</strong> {{ datosPaciente.nombre }}</h5>
        <h5><strong>Cédula:</strong> {{ datosPaciente.cedula }}</h5>
    </div>
    <div class="row justify-content-around">
        <h5><strong>Edad:</strong> {{ datosPaciente.edad }}</h5>
        <h5><strong>Género:</strong> {{ datosPaciente.genero }}</h5>
        <h5><strong>Peso:</strong> {{ datosPaciente.peso }}Kg</h5>
        <h5><strong>Estatura:</strong> {{ datosPaciente.estatura }}cm</h5>
    </div>
    <h3 class="mx-3"><strong>Datos del Doctor</strong></h3>
    <div class="row justify-content-around">
        <h5><strong>Nombre:</strong> {{ datosDoctor.nombre }}</h5>
        <h5><strong>Especialidad:</strong> {{ datosDoctor.especialidad }}</h5>
    </div>
    <h3 class="mx-3"><strong>Reporte</strong></h3>
    <div class="row container mx-5">
        <p class="report">{{ reporte }}</p>
    </div>
</div>
